<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/preface"><em>Preface</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/introduction">Introduction: “Caucasians” and the Political History of Racial Identities</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01">1 Before the “Caucasian Race”: Antecedents of European Racialism, ca. 1000–1684</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2 Enlightenment Science and the Invention of the “Caucasian Race,” 1684–1795</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 Passage into “Our Ordinary Forms of Expression”: The “Caucasian Race,” ca. 1795–1850</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 Racialized Nationalism and the Partial Eclipse of the “Caucasian Race,” ca. 1840–1935</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 The Color Line and the “Caucasian Race” Revival, 1935–51</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6 Not-so-Benign Racialism: The “Caucasian Race” after Decolonization, 1952–2005</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7 “Where Caucasian Means Black”: “Race,” Nation, and the Chechen Wars</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion: Deconstructing “Caucasia,” Dismantling Racism</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/author" title="Link target outside of Sample"><em>About the Author</em></span></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2583fe6f